import Utility from "@/helper/Utility"
import ConfigManager from "@/config/ConfigManager"
import { getCampaignsByConfig } from "./useProductDetail"
import { reactive, ref } from "vue"

/**
 *
 * @param {import("@/core/Campaign/model/CampaignModel").default} campaign
 * @param {Object} selectedOptions
 * @returns
 */
export const useCampaignOptionsService = function (campaign, selectedOptions, subscriptionList) {
    const extraJson = ref(null)
    if (!Utility.isEmptyStr(campaign.extra)) {
        extraJson.value = campaign.extraJson
    }

    const rawOthers = ref(null)
    const rawAddOns = ref(null)
    const rawAppetizers = ref(null)

    const states = reactive({
        meats: null,
        addOn: [],
        addOns: [],
        ingredients: null,
        multiIngredients: null,
        appetizers: null,
        others: [],
        isShowAddOnTab: false,
        subscriptionList: subscriptionList
    })

    const optionStates = reactive({
        meats: null,
        others: [],
        ingredients: [],
        multiIngredients: [],
        appetizers: [],
        quantity: null,
        addOn: [],
        addOns: [],
        subScription: null,
    })

    //#region get sections
    const getMeatsType = function () {
        if (campaign.subCampaignStyles && campaign.subCampaignStyles.styles) {
            let arr = campaign.subCampaignStyles.styles
            for (const item of arr) {
                item.img = ConfigManager.getBlobUrl() + "/campaigns/" + item.campaignId
            }
            states.meats = arr
            // console.log(states.meats);
            setSelectedOptions("meats")
        } else {
            states.meats = null
        }
    }

    const getOthers = async function () {
        if (extraJson.value != null) {
            let configArr = extraJson.value?.other ?? [];
            if(configArr.length > 0){
                for (let i = 0; i < configArr.length; i++) {
                    // check str duplicate before call api
                    let previous = configArr[i - 1]?.config
                    let current = configArr[i].config
                    if(previous !== undefined && previous == current){
                        if (rawOthers.value != null && rawOthers.value.length > 0) {

                            let formType = configArr[i].config?.type ?? "radio"

                            states.others.push({
                                ...configArr[i],
                                type: formType,
                                data: rawOthers.value,
                            })
                            optionStates.others.push({
                                ...configArr[i],
                                type: formType,
                                data: null
                            })
                        }
                    }else {
                        try {
                            rawOthers.value = await apiGetCampaignsByConfig(configArr[i].config)
                            if (rawOthers.value != null && rawOthers.value.length > 0) {

                                let formType = configArr[i].config?.type ?? "radio"

                                states.others.push({
                                    ...configArr[i],
                                    type: formType,
                                    data: rawOthers.value,
                                })
                                optionStates.others.push({
                                    ...configArr[i],
                                    type: formType,
                                    data: null
                                })
                            }
                        } catch (error) {
                            // do nothing if can not get campaigns
                        }
                    }
                }
                setSelectedOptions("others")
            }
        } else {
            states.others = []
        }
    }

    const getAddOn = async function () {
        if (extraJson.value != null) {
            let config = extraJson.value?.addon_config_list ?? null;
            if (config != null) {
                let res = await apiGetCampaignsByConfig(config)
                if (res != null && res.length > 0) {
                    states.addOn = res
                }
            }
        } else {
            states.addOn = []
        }
    }

    const getAddOns = async function () {
        if (extraJson.value != null) {
            states.addOns = extraJson.value?.addons_config_list ?? null;
            if(states.addOns != null && states.addOns !== undefined && states.addOns.length > 0){
                for(let i = 0; i < states.addOns.length; i++){
                    // check str duplicate before call api
                    let previous = states.addOns[i - 1]?.config
                    let current = states.addOns[i].config
                    if(previous !== undefined && previous == current){
                        setAddOn(i)
                    }else {
                        if (states.addOns[i].config != null) {
                            rawAddOns.value = await apiGetCampaignsByConfig(states.addOns[i].config)
                            setAddOn(i)
                        }
                    }
                    // splice header undefined
                    if(states.addOns[i].header == '' || states.addOns[i].header_en == '' || states.addOns[i].header == undefined || states.addOns[i].header_en == undefined){
                        states.addOns.splice(i, 1)
                    }

                    if(states.addOns[i]?.list?.length > 0){
                        states.isShowAddOnTab = true
                    }

                    if(extraJson.value?.remarks[i]?.length > 0){
                        states.isShowAddOnTab = true
                    }
                }
            }
        } else {
            states.addOns = []
        }
    }
    const setAddOn = (i) => {
        if (rawAddOns.value != null && rawAddOns.value.length > 0) {
            let array = states.addOns
            array[i].list = rawAddOns.value
            states.addOns = array
        }
    }


    const getIngredients = function () {
        if (extraJson.value != null) {
            let config = extraJson.value?.remark ?? null;
            states.ingredients = config
            optionStates.ingredients.push({
                list: states.ingredients,
                type: 'checkbox',
                data: []
            })
            setSelectedOptions("ingredients")
        } else {
            states.ingredients = null
        }
    }

    const getMultiIngredients = function () {
        if (extraJson.value != null) {
            let config = extraJson.value?.remarks ?? null;
            if(config != null && config.length > 0){
                states.multiIngredients = config
                for(const items of states.multiIngredients){
                    optionStates.multiIngredients.push({
                        ...items,
                        type: 'checkbox',
                        data: []
                    })
                }
                setSelectedOptions("multiIngredients")
            }
        } else {
            states.multiIngredients = null
        }
    }

    const getAppetizers = async function () {
        if (extraJson.value != null) {
            states.appetizers = extraJson.value?.appetizers ?? null;
            if(states.appetizers != null && states.appetizers !== undefined){
                for(let i = 0; i < states.appetizers.length; i++){
                    let previous = states.appetizers[i - 1]?.config
                    let current = states.appetizers[i].config
                    if(previous !== undefined && previous == current){
                        setAppetizer(i)
                    }else{
                        if (states.appetizers[i].config != null) {
                            rawAppetizers.value = await apiGetCampaignsByConfig(states.appetizers[i].config)
                            setAppetizer(i)
                        }
                    }
                }
                setSelectedOptions("appetizers")
            }
        } else {
            states.appetizers = null
        }
    }
    const setAppetizer = (i) => {
        if(states.appetizers[i].maximum_item !== undefined){
            optionStates.appetizers.push({
                ...states.appetizers[i],
                type: 'checkbox',
                data: [],
                list: [...rawAppetizers.value]
            })
        }
        let array = states.appetizers
        array[i].list = rawAppetizers.value
        states.appetizers = array
    }

    const apiGetCampaignsByConfig = async function (config) {
        return new Promise((resolve, reject) => {
            getCampaignsByConfig(config).then((res) => {
                resolve(res)
                return res
            }).catch((err) => {
                reject(err)
            })
        })
    }
    //#endregion get sections

    const extractData = function () {
        getMeatsType()
        getOthers()
        getAddOn()
        getAddOns()
        getIngredients()
        getMultiIngredients()
        getAppetizers()
        setSelectedOptions("subscription")
    }

    /**
     *
     * @param {"meats"|"others"|"ingredients"|"multiIngredients"|"appetizer"|"addOn"|"addOns"|"appetizers"} target
     */
    const setSelectedOptions = function (target) {
        // console.log("selectedOptions", selectedOptions)
        if (target == "meats") {
            if (selectedOptions.meats != null) {
                optionStates.meats = selectedOptions.meats
            }
        } else if (target == "others") {
            // console.log(states.others, optionStates.others)
            // loop through optionStates.others
            for (const item of optionStates.others) {
                let config = states.others.filter(x => x.config == item.config)
                let campaigns = config[0].data
                let filteredArray = campaigns.filter(x => {
                    return selectedOptions.remark.others.findIndex(y => y.campaign_id == x.id) !== -1;
                })
                if (item.type == "radio" && filteredArray.length > 0) {
                    item.data = filteredArray[0]
                }
            }
        }
        else if (target == "addOn") {
            // console.log("add on states", optionStates.addOn)
            // loop through qty controllers that generate from component QuantityControlGroup
            for (const item of optionStates.addOn) {
                let exists = selectedOptions.sideCampaigns.find(x => x.campaignId == item.data.id)
                if (exists != null) {
                    item.qty = exists.quantity
                }

            }
        }
        else if (target == "addOns") {
            // console.log("add ons states", optionStates.addOns)
            // loop through qty controllers that generate from component QuantityControlGroup
            
            if(optionStates.addOns.length > 0){
                const array = optionStates.addOns;
                for (let i = 0; i < array.length; i++) {
                    let addOn = array[i]
                    if (addOn && addOn.length > 0) {
                        for(let j = 0; j < addOn.length; j++){
                            let item = addOn[j]
                            if(selectedOptions.remark.addOns.length > 0){
                                for(const selected of selectedOptions.remark.addOns){
                                    if(selected.index == i){
                                        let exists = selected.items.find(x => x.campaign_id == item.data.id)
                                        if (exists) {
                                            item.qty = exists.quantity
                                        }
                                    }

                                }
                            }
                        }
                    }
                }
            }
        }
        else if (target == "ingredients") {
            // not support yet
            // console.log(states.ingredients, optionStates.ingredients)
            if(optionStates.ingredients.length > 0){
                if(selectedOptions.remark.remarks.length > 0){
                    if(optionStates.ingredients){
                        for(const selected of selectedOptions.remark.remarks){
                            let filteredArray = optionStates.ingredients.filter(x => {
                                return selected.items.findIndex(y => y.id == x.id) !== -1;
                            })
                            if (filteredArray.length > 0) {
                                optionStates.ingredients.data = [...filteredArray]
                            }
                        }
                    }
                }
                optionStates.ingredients = JSON.parse(JSON.stringify(optionStates.ingredients))
            }
        }
        else if (target == "multiIngredients") {
            // console.log(states.multiIngredients, optionStates.multiIngredients)

            if(optionStates.multiIngredients.length > 0){
                for (let i = 0; i < optionStates.multiIngredients.length; i++) {
                    let item = optionStates.multiIngredients[i]
                    if(selectedOptions.remark.remarks.length > 0){
                        let campaigns = item.items
                        if(campaigns){
                            for(const selected of selectedOptions.remark.remarks){
                                if(selected.index == i){
                                    let filteredArray = campaigns.filter(x => {
                                        return selected.items.findIndex(y => y.id == x.id) !== -1;
                                    })
                                    if (filteredArray.length > 0) {
                                        optionStates.multiIngredients[i].data = [...filteredArray]
                                    }
                                }
                            }
                        }
                    }
                }
                optionStates.multiIngredients = JSON.parse(JSON.stringify(optionStates.multiIngredients))
            }
        }
        else if (target == "appetizers") {
            if(states.appetizers.length > 0){
                for(let i = 0; i < optionStates.appetizers.length; i++){
                    let item = optionStates.appetizers[i]
                    if(selectedOptions.remark.appetizers.length > 0){
                        for(const selected of selectedOptions.remark.appetizers){
                            if(selected.index == i){
                                if(item?.maximum_item !== undefined){
                                    let campaigns = item.list
                                    if(campaigns){
                                        let filteredArray = campaigns.filter(x => {
                                            return selected.items.findIndex(y => y.campaign_id == x.id) !== -1;
                                        })
                                        if (filteredArray.length > 0) {
                                            item.data = [...filteredArray]
                                        }
                                    }
                                }else {
                                    for(let k of item){
                                        let exists = selected.items.find(x => x.campaign_id == k.data.id)
                                        if (exists) {
                                            k.qty = exists.quantity
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        } else if (target == "subscription") {
            if (states.subscriptionList != null) {
                // find subscription item by Selected 
                optionStates.subScription = states.subscriptionList.find(x => x.Selected == true)
                
            }
        }
    }

    // call extract data
    extractData()

    return {
        optionStates,
        campaignOptions: states,
        setSelectedOptions,
    }
}

export default useCampaignOptionsService
